import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class CommonSampleService extends Resource {
    async getSamplesOfCaseAsCards(labId, casId) {
        return this.axios.get(`/common/laboratories/${labId}/cases/${casId}/samples/cards`).then(response => response.data)
    }

    async findByLabel(laboratoryId, sampleLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/${sampleLabel}/findByLabel`)
        return response.data
    }

    async getTracking(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/tracking`)
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/samples/search', { params })
        return response.data
    }

    async getSamples(labId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/samples`)
        return response.data
    }

    async hierarchicalSampleIndexTree(labId, caseId, samId, withAttachments, withIncidents) {
        const params = {
            withAttachments,
            withIncidents
        }
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/samples/${samId}/hierarchicalSampleIndexTree`, { params })
        return response.data
    }

    async getPreviousCasesSamples(loggedLaboratory, caseId, patId) {
        const params = {
            loggedLaboratory
        }
        const response = await this.axios.get(`/common/patients/${patId}/previousCases/${caseId}/samples`, { params })
        return response.data
    }

    async getNextSampleNumbers(laboratoryId, params) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/getNextSampleNumbers`, { params })
        return response.data
    }

    async exportTo(laboratoryId, caseId, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/common/laboratories/${laboratoryId}/cases/${caseId}/samples/export`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
}

export const SAMPLE_TYPE_WORKFLOW = {
    GROSSING_BIOPSIES: { code: 'GROSSING_BIOPSIES' },
    PROCESSING_CYTOLOGIES: { code: 'PROCESSING_CYTOLOGIES' }
}

export default new CommonSampleService()
